import { PropsWithChildren } from "react";

export interface IMDSDialogProps extends PropsWithChildren {
  isOpen: boolean;
  isDismissable?: boolean;
  handleClose?: () => void;
  fluidWidth?: boolean;
}

export enum MDSDialogSlotName {
  Header = "header",
  Content = "content",
  Footer = "footer",
  ButtonsLeft = "buttonsLeft",
  ButtonsRight = "buttonsRight",
}
